function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCardBrex = function SvgCardBrex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h32a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4z",
    style: {
      fill: "#15181d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.941 17.621c0-.053.014-.106.042-.151l.461-.768a.293.293 0 0 1 .252-.143h2.088c.162 0 .294.132.294.294v4.118a.294.294 0 0 1-.294.294H3.696a.293.293 0 0 1-.252-.143l-.461-.768a.299.299 0 0 1-.042-.151v-2.582zm3.53-.768c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255-.294a.294.294 0 0 0-.294.294v2.157c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 19.01v-2.157a.294.294 0 0 0-.294-.294h-.98zm-2.255 2.843c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255.294a.294.294 0 0 0-.294.294v.98c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 20.97v-.98a.294.294 0 0 0-.294-.294h-.98z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#34383f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.711 10.697a1.18 1.18 0 0 0-.95.473l-.232.308a.513.513 0 0 1-.401.2H29v4.935h1.618a1.18 1.18 0 0 0 .95-.473l.232-.307a.502.502 0 0 1 .401-.201h4.133v-4.935h-1.623zm.339 3.652h-1.73a1.18 1.18 0 0 0-.95.473l-.232.308a.513.513 0 0 1-.401.2h-1.453v-2.367h1.73a1.18 1.18 0 0 0 .95-.473l.232-.307a.513.513 0 0 1 .401-.201h1.458l-.005 2.367z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgCardBrex;